/**
 * Defines the possible values for profiles.
 * Each profile has a different set of preferences.
 * */
export type SiteMonitoringProfile = 'support' | 'client';

/** Current supported profiles, can be extended in the future */
export const SITE_MONITORING_PROFILES: Array<SiteMonitoringProfile> = ['support', 'client'];
